<svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <g filter="url(#filter0_f_18_6496)">
        <circle cx="29" cy="29" r="25" fill="url(#paint0_radial_18_6496)" />
    </g>
    <circle cx="29" cy="29" r="6" fill="white" />
    <defs>
        <filter
            id="filter0_f_18_6496"
            x="0"
            y="0"
            width="58"
            height="58"
            filterUnits="userSpaceOnUse"
            color-interpolation-filters="sRGB"
        >
            <feFlood flood-opacity="0" result="BackgroundImageFix" />
            <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="BackgroundImageFix"
                result="shape"
            />
            <feGaussianBlur
                stdDeviation="2"
                result="effect1_foregroundBlur_18_6496"
            />
        </filter>
        <radialGradient
            id="paint0_radial_18_6496"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(29 29) rotate(30.7355) scale(64.5697)"
        >
            <stop stop-color="white" stop-opacity="0" />
            <stop offset="1" stop-color="white" />
            <stop offset="1" stop-color="white" />
        </radialGradient>
    </defs>
</svg>
